module.exports = __webpack_public_path__ + "static/media/hand.e5a46b1f.svg";